import { computed } from 'vue'
import type { Ref } from '@vue/reactivity'
import type { WorkedHour } from '@/interfaces'

export function useWorkedHours(currentHours: Ref<any[]>, limit: number = 3) {

    const removeHourDisabled = computed(() => currentHours.value.length <= 1);
    const addHourDisabled = computed(() => currentHours.value.length >= limit);
    const hasEmptyHours = computed(() => currentHours.value.some((hour: WorkedHour) => hour.amount === null || hour.amount === 0 || hour.percentage === null || hour.percentage === 0));

    function addHour(): void {
        currentHours.value = [...currentHours.value, { amount: null, percentage: null }];
    }

    function removeHour(): void {
        currentHours.value = currentHours.value.toSpliced(currentHours.value.length - 1, 1);
    }

    return {
        hours: currentHours,
        addHour,
        removeHour,
        hasEmptyHours,
        addHourDisabled,
        removeHourDisabled
    };
}